import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Users, ShoppingBag } from 'lucide-react';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from './ui/carousel';

const experienceImages = [
  {
    url: "https://customer-assets.emergentagent.com/job_santomato-pizza/artifacts/eeaz8c5m_2.png",
    alt: "Amiche che mangiano pizza insieme"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_santomato-pizza/artifacts/7hxtwcqs_3.png",
    alt: "Bambini felici con la pizza"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_santomato-pizza/artifacts/iewwwgl0_4.png",
    alt: "Coppia che si gode la pizza"
  }
];

const features = [
  { icon: Users, label: "TAVOLATE GRANDI" },
  { icon: Zap, label: "SERVIZIO VELOCE" },
  { icon: ShoppingBag, label: "ANCHE TAKE AWAY" }
];

const Experience = () => {
  return (
    <section 
      id="experience"
      data-testid="experience-section"
      className="min-h-screen bg-white py-16 md:py-24 relative overflow-hidden"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        {/* Section Title */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12 md:mb-16"
        >
          <h2 
            className="font-fredoka font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-black uppercase mb-4"
            data-testid="experience-title"
          >
            QUI NON VIENI
            <br />
            <span className="text-santomato-red">SOLO A MANGIARE</span>
          </h2>
        </motion.div>

        {/* Image Carousel */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="mb-12 md:mb-16"
        >
          <Carousel className="w-full max-w-4xl mx-auto" data-testid="experience-carousel">
            <CarouselContent>
              {experienceImages.map((image, index) => (
                <CarouselItem key={index}>
                  <div className="card-brutal overflow-hidden">
                    <img
                      src={image.url}
                      alt={image.alt}
                      className="w-full h-64 md:h-96 object-cover"
                      loading="lazy"
                    />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="hidden md:flex -left-12 border-4 border-black bg-santomato-yellow hover:bg-santomato-red hover:text-white" />
            <CarouselNext className="hidden md:flex -right-12 border-4 border-black bg-santomato-yellow hover:bg-santomato-red hover:text-white" />
          </Carousel>
        </motion.div>

        {/* Features */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6"
        >
          {features.map((feature, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.05, rotate: [-1, 1, -1, 0] }}
              className="card-brutal bg-santomato-yellow p-4 md:p-6 text-center"
              data-testid={`experience-feature-${index}`}
            >
              <feature.icon size={40} className="mx-auto mb-3 text-black" strokeWidth={2.5} />
              <span className="font-fredoka font-bold text-sm md:text-base text-black uppercase">
                {feature.label}
              </span>
            </motion.div>
          ))}
        </motion.div>

        {/* Description */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="mt-12 text-center"
        >
          <p className="font-nunito font-bold text-lg md:text-xl text-gray-700 max-w-2xl mx-auto">
            Ambiente giovane e informale, dove ogni serata diventa speciale. 
            Porta gli amici, la famiglia, o vieni da solo: qui ti sentirai sempre a casa.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Experience;
